import styled from 'styled-components';

export const BoldText = styled.strong`
  font-weight: 500;
`;
